module.exports = "/_next/static/images/uwa-08728b74510858769c3b37f1e78c8a45.png";